const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const findInmatesSchema = (data) => {
  const schema = Joi.object({
    StateID: Joi.number().min(1).required().messages({
      "number.min": currentLang?.ValidationSchema?.Please_Choose_State,
      "any.required": currentLang?.ValidationSchema?.Please_Choose_State,
      "number.base": currentLang?.ValidationSchema?.Please_Choose_State,
      "any.only": currentLang?.ValidationSchema?.Please_Choose_State,
      "string.empty": currentLang.ValidationSchema?.Please_Choose_State,
    }),


    FacilityName: Joi.number().min(1).required().messages({
      "number.min": currentLang?.ValidationSchema?.Please_Choose_Facility,
      "any.required": currentLang?.ValidationSchema?.Please_Choose_Facility,
      "number.base": currentLang?.ValidationSchema?.Please_Choose_Facility,
      "any.only": currentLang?.ValidationSchema?.Please_Choose_Facility,
      "string.empty": currentLang?.ValidationSchema?.Please_Choose_Facility,
    }),

    // Dob: Joi.date()
    //   .required()
    //   .messages({
    //     "any.required": "Please enter Date of Birth.",
    //     "date.base": "Please enter Date of Birth.",
    //     "string.empty": "Please enter Date of Birth.",
    //   }),
    UserFirstName:Joi.string()
      .trim()
      .required()
      .messages({
        "any.required": currentLang?.ValidationSchema?.Please_enter_firstname,
        "string.empty": currentLang?.ValidationSchema?.Please_enter_firstname,
      }),
    UserLastName: Joi.string()
      .trim()
      .required()
      .messages({
        "any.required": currentLang?.ValidationSchema?.Please_enter_last_name,
        "string.empty": currentLang?.ValidationSchema?.Please_enter_last_name,
      }),
  }).unknown(true); // Allow unknown keys in the object (useful if you're validating only part of the data)

  return schema.validate(data, { abortEarly: false, convert: true });
};

module.exports = findInmatesSchema;
